__turbopack_context__.v({
  "active": "Menu-module__exN1ha__active",
  "main": "Menu-module__exN1ha__main",
});
